import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { catalogues, DEFAULT_LOCALE } from '@monrdv/shared';

/**
 * Translation setup.
 *
 * French is the default and the fallback — this business runs in French, and an untranslated
 * string should surface as French rather than English. The catalogue itself lives in
 * `@monrdv/shared` so the API can render the same strings into a PDF or an SMS.
 */
void i18next.use(initReactI18next).init({
  resources: {
    fr: { translation: catalogues.fr },
    en: { translation: catalogues.en },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  // A missing key is a bug we want to see in development, not paper over.
  saveMissing: import.meta.env.DEV,
  missingKeyHandler: import.meta.env.DEV
    ? (_lng, _ns, key) => console.warn(`[i18n] missing key: ${key}`)
    : undefined,
});

export { i18next };
